import { render } from "./Loader.vue?vue&type=template&id=6fa30b2c&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=6fa30b2c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6fa30b2c"

export default script